import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faCircleCheck,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import InfoBanner from "../../student_portal/dashboard_Content/infoBanner/InfoBanner";
import Hotel_dashboard_buckets from "./hotel_dashboard_buckets/Hotel_dashboard_buckets";
import Receptionist_card from "../../../../common_components/common-cards/receptionist_card/Receptionist_card";

function Hotel_dashboard() {
  const handleFilterSelect = (value) => {
    console.log(value); // apply filter logic here
    setOpenFilter(false);
  };

  const reptionistCardsData = [
    {
      name: "Priyank Sharma",
      subTitle: "Arriving Soon",
      id: "APP12546",
      email: "priyank2254@gmail.com",
      contact: "+91 7869875654",
      uploadedBy: "18/01/2026",
      uploadDate: "18/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleCheck },
        { doc: "CV", icon: faCircleInfo },
      ],
      note: "Prepare the intern's arrival",
      status: "Confirmed",
    },
    {
      name: "Rahul Verma",
      subTitle: "Arriving Soon",
      id: "APP12547",
      email: "rahul.verma@gmail.com",
      contact: "+91 9876543210",
      uploadedBy: "Admin Team",
      uploadDate: "20/01/2026",
      documents: [
        { doc: "Travel Insurance", icon: faCircleCheck },
        { doc: "Motivation", icon: faCircleInfo },
        { doc: "Statement", icon: faCircleInfo },
        { doc: "CV", icon: faCircleCheck },
      ],
      note: "Prepare the intern's arrival",
      status: "Pending",
    },
  ];

  const [openFilter, setOpenFilter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target))
        setOpenFilter(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);
  return (
    <>
      <section className="Collage_dashboard application_section">
        <div>
          <div className="mb-3">
            <Hotel_dashboard_buckets />
          </div>

          <div className="mb-3">
            <div className="heading_btn_holder">
              <div className="heading_text_holder">
                <h1>Applications</h1>
              </div>
              <div className="btn_holder">
                {/* SECOND DROPDOWN */}
                <div className="dropdown_wrapper" ref={filterRef}>
                  <button
                    className="dark_btn"
                    onClick={() => setOpenFilter(!openFilter)}
                  >
                    Filter
                    <div className="aap_icon_holder">
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`dropdown_icon ${
                          openFilter ? "rotate" : ""
                        }`}
                      />
                    </div>
                  </button>

                  {openFilter && (
                    <div className="custom_dropdown">
                      <button
                        className="dropdown_item"
                        onClick={() => handleFilterSelect("Active")}
                      >
                        Active
                      </button>

                      <button
                        className="dropdown_item"
                        onClick={() => handleFilterSelect("Pending")}
                      >
                        Pending
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="row g-3">
              {reptionistCardsData.map((item, index) => (
                <div
                  className=" col-xl-4 col-lg-6 col-md-6 col-sm-12 "
                  key={index}
                >
                  <Receptionist_card
                    name={item.name}
                    subTitle={item.subTitle}
                    id={item.id}
                    email={item.email}
                    contact={item.contact}
                    uploadedBy={item.uploadedBy}
                    uploadDate={item.uploadDate}
                    documents={item.documents}
                    note={item.note}
                    status={item.status}
                    actions={
                      item.status === "Confirmed" ? (
                        <>
                          <Button className="info_btn action_click">
                            Download Docs
                          </Button>
                          <Button className="delete_btn action_click">
                            End Internship
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button className="info_btn action_click">
                            Download Docs
                          </Button>
                          <Button className="download_btn action_click">
                            Add Docs
                          </Button>
                        </>
                      )
                    }
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="mb-3">
            <InfoBanner />
          </div>
        </div>
      </section>
    </>
  );
}

export default Hotel_dashboard;
